import { render, staticRenderFns } from "./section-terms.vue?vue&type=template&id=9aa45fde&scoped=true"
import script from "./section-terms.vue?vue&type=script&lang=js"
export * from "./section-terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa45fde",
  null
  
)

export default component.exports